<template>
  <v-layout column>
    <v-navigation-drawer v-model="right" fixed right light width="400">
      <v-flex class="pl-2 pt-1" style="height: 100vh" v-if="loading">
        <v-icon @click.stop="right = !right">close</v-icon>
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular
            indeterminate
            color="#c0c0c0"
          ></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex class="pl-2 pt-1" v-if="!loading && error !== ''">
        <div class="error">{{ error }}</div>
      </v-flex>
      <v-flex class="pl-2 pt-1" v-if="!loading && billing">
        <v-icon @click.stop="right = !right">close</v-icon>
        <v-list-tile>
          <v-flex sm12 md12 xs12>
            <v-subheader v-if="billing">{{
              billing.user?.name || ""
            }}</v-subheader>
          </v-flex>
        </v-list-tile>
        <v-divider />
        <v-list-tile style="height: 50px">
          <v-flex sm12 md6 xs6>
            <v-subheader v-if="billing">
              <a
                :href="
                  billing.transaction
                    ? 'https://beta.dashboard.pagar.me/#/transactions/' +
                      billing.transaction.id
                    : ''
                "
                target="_blank"
              >
                {{ billing.transaction ? "#" + billing.transaction.id : "" }}
              </a>
            </v-subheader>
          </v-flex>
          <v-flex sm12 md6 xs6>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 30px;
              "
              :class="`detail-status detail-status--${
                this.status === 'Atrasada' ? 'atrasada' : billing.status
              }`"
            >
              {{ status }}
            </div>
          </v-flex>
        </v-list-tile>
        <v-card
          color="red darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.status === 'error'"
        >
          Erro ao processar essa fatura. Caso necessário, solicite ação da
          Equipe de Faturamento
          <v-icon color="white" right>warning</v-icon>
        </v-card>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="
            billing.free_reason &&
            (billing.status === 'free' || billing.status === 'free_pending')
          "
        >
          Motivo de abono: {{ billing.free_reason }}
        </v-card>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.pending_reason && billing.status === 'pending_approval'"
        >
          Motivo da Análise: {{ billing.pending_reason }}
        </v-card>
        <v-card
          color="red darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.negativation_id && billing.status !== 'paid'"
        >
          Essa fatura foi enviada para negativação junto ao SERASA{{
            billing.negativation_at
              ? " em " + (billing.negativation_at | formatDateTime)
              : ""
          }}.
        </v-card>
        <v-card
          color="orange darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.negativation_id && billing.status === 'paid'"
        >
          Essa fatura foi enviada para negativação junto ao SERASA. Porém, já
          foi paga.
        </v-card>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.negotiated_at"
        >
          Renegociação realizada em {{ billing.negotiated_at | formatDateTime }}
        </v-card>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.parceled_at"
        >
          Parcelamento realizado em {{ billing.parceled_at | formatDateTime }}
        </v-card>
        <v-card
          color="yellow darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.due_date_change_count > 0"
        >
          Vencimento Alterado em
          {{ billing.due_date_changed_at | formatDateTime }}
          <span v-if="billing.due_date_changed_by"
            >por {{ billing.due_date_changed_by }}</span
          >
        </v-card>
        <v-card
          color="indigo darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.unique_billing"
        >
          Fatura Unificada <v-icon color="white" right>electric_bolt</v-icon>
        </v-card>
        <v-card
          color="orange darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.dismembered"
        >
          Fatura Desmembrada <v-icon color="white" right>scoreboard</v-icon>
        </v-card>
        <v-card
          color="purple darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.hasOwnProperty('changes')"
          @click.prevent="showRecalcBilling(billing)"
        >
          Fatura Recalculada <v-icon color="white" right>find_in_page</v-icon>
        </v-card>
        <v-card
          color="red darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.irregular_payment"
        >
          Pagamento Irregular
          <br />
          {{ billing.irregular_payment_reason }}
        </v-card>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.skip_charge"
        >
          Cliente irá pagar até {{ billing.skip_charge | formatBoletoExp }}
        </v-card>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.process_type === 'manual'"
        >
          Fatura processada por planilha
        </v-card>
        <v-card
          color="blue-grey darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.process_type === 'xml'"
        >
          Fatura processada por XML
        </v-card>
        <v-card
          color="teal darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.belongs_to_cancel_charge === true"
        >
          Esta fatura agora compõe a fatura de débitos. Seu parcelamento foi
          realizado automaticamente pelo sistema
        </v-card>
        <v-card
          color="orange darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.process_type === 'no_contract'"
        >
          Fatura gerada por cancelamento de contrato na concessionária
        </v-card>
        <v-card
          color="orange darken-2"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.process_type === 'empty_billing'"
        >
          Faturado por fatura em branco
        </v-card>
        <v-card
          color="yellow darken-2"
          class="text-xs-center black--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.total_provisioned"
        >
          Conta da Concessionária Provisionada
        </v-card>
        <v-card
          color="yellow darken-2"
          class="text-xs-center black--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-else-if="billing.bill_status === 'withheld'"
        >
          Conta da Concessionária Retida
        </v-card>
        <v-card
          color="#B71C1C"
          class="text-xs-center white--text pl-2 pr-2 pt-3 pb-3 mb-2"
          v-if="billing.warning === true"
        >
          Erro: {{ billing.warning_reason }}
        </v-card>
        <v-list-tile avatar v-if="billing">
          <v-list-tile-action>
            <v-icon class="grey--text">tag</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>ID</v-list-tile-sub-title>
            <v-list-tile-title>
              <div>{{ billing.id }}</div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Competencia -->

        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">calendar_today</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Competência</v-list-tile-sub-title>
            <v-list-tile-title v-text="billing.competence" />
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-action>
            <v-icon class="grey--text">date_range</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Faturado em</v-list-tile-sub-title>
            <v-list-tile-title>
              <div>{{ billing.created_at | formatDateTime }}</div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-action>
            <v-icon class="grey--text">edit_calendar</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title v-if="billing"
              >Atualizado em</v-list-tile-sub-title
            >
            <v-list-tile-title>
              <div>{{ billing.updated_at | formatDateTime }}</div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar v-if="billing.status === 'in_queue'">
          <v-list-tile-action>
            <v-icon class="blue--text">schedule_send</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title v-if="billing"
              >Programado para</v-list-tile-sub-title
            >
            <v-list-tile-title>
              <div>{{ billing.charge_at | formatDateTime }}</div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          avatar
          class="v-list-item"
          v-if="
            billing.transaction &&
            (billing.transaction.boleto_expiration_date ||
              billing.transaction.expire_at ||
              billing.transaction.pix_expiration_date)
          "
        >
          <v-list-tile-action>
            <v-icon
              :class="billing.status === 'overdue' ? 'red--text' : 'grey--text'"
              >event</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Vencimento ({{
                billing.transaction && billing.payment_service === "pagarme"
                  ? billing.transaction.payment_method
                  : ""
              }})</v-list-tile-sub-title
            >
            <v-list-tile-title>
              <span
                v-if="billing.due_date_changed_at"
                style="text-decoration: line-through"
                class="caption grey--text"
              >
                {{ billing.original_due_date | formatBoletoExp }}
              </span>
              <span
                v-if="
                  billing.payment_service === 'pagarme' &&
                  billing.transaction &&
                  billing.transaction.payment_method === 'boleto'
                "
              >
                {{
                  billing.transaction.boleto_expiration_date | formatBoletoExp
                }}
              </span>
              <span
                v-else-if="
                  billing.transaction &&
                  billing.payment_service === 'pagarme' &&
                  billing.transaction.payment_method === 'pix'
                "
              >
                {{ billing.transaction.pix_expiration_date | formatBoletoExp }}
              </span>
              <span
                v-else-if="
                  billing.transaction &&
                  billing.payment_service === 'boletosimples'
                "
              >
                {{ billing.transaction.expire_at | formatBoletoExp }}
              </span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar v-if="billing.due_date_utility">
          <v-list-tile-action>
            <v-icon class="grey--text">event_note</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Vencimento Concessionária</v-list-tile-sub-title
            >
            <v-list-tile-title>
              <div>{{ billing.due_date_utility | formatBoletoExp }}</div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <br
          v-if="
            (billing.status === 'waiting_payment' ||
              billing.status === 'opened') &&
            billing?.transaction &&
            !billing?.transaction?.pix_qr_code
          "
        /> -->
        <v-list-tile
          avatar
          class="v-list-item"
          v-if="
            (billing.status === 'waiting_payment' ||
              billing.status === 'opened') &&
            billing?.transaction &&
            !billing?.transaction?.pix_qr_code
          "
        >
          <v-list-tile-action>
            <v-icon class="grey--text">mdi-barcode</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <div class="sub-title" v-if="billing.payment_service === 'pagarme'">
              {{ billing.transaction.boleto_barcode || "" }}
            </div>
            <div
              class="sub-title"
              v-if="billing.payment_service === 'boletosimples'"
            >
              {{ billing.transaction.line || "" }}
            </div>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <br
          v-if="
            (billing.status === 'waiting_payment' ||
              billing.status === 'opened') &&
            billing?.transaction &&
            !billing?.transaction?.pix_qr_code
          "
        /> -->
        <v-list-tile
          avatar
          class="v-list-item"
          v-if="billing?.transaction && billing?.transaction?.pix_qr_code"
        >
          <v-list-tile-action>
            <v-icon class="grey--text">qr_code</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Pix Copia e Cola</v-list-tile-sub-title>
            <v-list-tile-title>
              <a
                @click="copyPixCode(billing.transaction.pix_qr_code)"
                class="copy_pix"
                >Copiar código</a
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          avatar
          class="v-list-item"
          v-if="billing.status === 'paid'"
        >
          <v-list-tile-action>
            <v-icon class="green--text">event_available</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Pago em: </v-list-tile-sub-title>
            <v-list-tile-title>
              {{
                (billing.transaction?.paid_at ||
                  billing.paid_at ||
                  billing.informed_payment_date ||
                  billing.transaction?.date_updated) | formatBoletoExp
              }}
            </v-list-tile-title>
            <v-list-tile-sub-title
              v-if="
                !billing.transaction?.paid_at &&
                billing.informed_payment_date &&
                billing.informed_receipt_url
              "
              :href="billing.informed_receipt_url"
              target="_blank"
              >Baixa manual por: {{ billing.payment_informed_by }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar v-if="plan20()">
          <v-list-tile-action>
            <v-icon color="green">event_note</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Pagamento até a data de vencimento</v-list-tile-sub-title
            >
            <v-list-tile-title>
              <div>R$ {{ billing.total | formatCurrency }}</div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar v-if="plan20()">
          <v-list-tile-action>
            <v-icon color="red">event_note</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Pagamento após a data de vencimento</v-list-tile-sub-title
            >
            <v-list-tile-title>
              <div>R$ {{ calculaValorFaturaAposVenc() | formatCurrency }}</div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          avatar
          class="v-list-item"
          v-if="billing.status === 'paid'"
        >
          <v-list-tile-action>
            <v-icon class="green--text">local_atm</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Valor Pago</v-list-tile-sub-title>
            <v-list-tile-title
              v-if="
                billing.total &&
                billing.transaction &&
                Number(billing.total.toFixed(2)) ===
                  Number(billing.transaction.amount || 0)
              "
              >R$ {{ (billing.transaction.paid_amount || 0) | formatCurrency }}
            </v-list-tile-title>
            <v-list-tile-title v-else>
              R$
              {{
                (billing.transaction?.paid_amount
                  ? (billing.transaction?.paid_amount || 0) / 100
                  : billing.total || 0) | formatCurrency
              }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="red--text">point_of_sale</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Multa + Juros</v-list-tile-sub-title>
            <v-list-tile-title>
              R$ {{ getJurosMultas() | formatCurrency }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider />
        <v-list-tile v-if="responsive">
          <v-text-field
            class="purple-input search-input"
            label="Buscar..."
            color="purple"
          />
        </v-list-tile>

        <!-- Unidade Consumidora -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">house</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Unidade Consumidora</v-list-tile-sub-title>
            <v-list-tile-title
              v-if="billing.consumer_units && billing.consumer_units.length > 0"
              v-text="billing.consumer_units[0].consumer_unit"
            />
            <v-list-tile-title v-else v-text="billing.consumer_unit" />
          </v-list-tile-content>
        </v-list-tile>

        <!-- Consumo kWh -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">offline_bolt</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Consumo kWh</v-list-tile-sub-title>
            <v-list-tile-title v-text="consumo" />
          </v-list-tile-content>
        </v-list-tile>

        <!-- Saldo kWh -->
        <v-list-tile avatar class="v-list-item" v-if="billing.balance">
          <v-list-tile-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon class="grey--text" v-on="on">offline_bolt</v-icon>
              </template>
              <span
                >O saldo será adicionado nas próximas faturas, quando o usuário
                tiver consumo menor que os créditos injetados.</span
              >
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Saldo kWh (futuro)</v-list-tile-sub-title>
            <v-list-tile-title
              v-text="billing.balance > 0 ? billing.balance.toFixed(0) : 0"
            />
          </v-list-tile-content>
        </v-list-tile>

        <!-- Créditos kWh -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">offline_bolt</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Créditos kWh</v-list-tile-sub-title>
            <v-list-tile-title v-text="billing.amount_kW" />
          </v-list-tile-content>
        </v-list-tile>

        <!-- Valor kWh -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">power_input</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Valor kWh R$</v-list-tile-sub-title>
            <v-list-tile-title
              >R$
              {{
                billing.energy_kWh_value | formatKWCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>

        <!-- Valor Creditos em R$ -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">flash_on</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Créditos R$</v-list-tile-sub-title>
            <v-list-tile-title
              >R$ {{ billing.tarifa | formatCurrency }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>

        <!-- Custo de Disponibilidade R$ -->
        <v-list-tile avatar class="v-list-item" v-if="billing.custo_disp">
          <v-list-tile-action>
            <v-icon class="grey--text">warning</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Custo de Disponibilidade R$</v-list-tile-sub-title
            >
            <v-list-tile-title
              >R$ {{ billing.custo_disp | formatCurrency }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>

        <!-- Pagamento de parcela -->
        <v-list-tile avatar class="v-list-item" v-if="billing.installment_info">
          <v-list-tile-action>
            <v-icon class="grey--text">list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Parcela {{ billing.installment_info.installment_sequence }} de
              {{
                billing.installment_info.num_installments
              }}</v-list-tile-sub-title
            >
            <v-list-tile-title
              >R$
              {{
                billing.installment_info.total_installment | formatCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>

        <!-- Valor pago para a Enercred -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">{{ icon_payment_type }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Pagamento Juntos</v-list-tile-sub-title>
            <v-list-tile-title
              >R$
              {{
                billing.total_enercred ||
                (billing.unique_billing
                  ? billing.total - billing.total_invoice
                  : billing.total) | formatCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <!-- Valor pago para a Enercred -->
        <v-list-tile avatar class="v-list-item" v-if="billing.unique_billing">
          <v-list-tile-action>
            <v-icon class="grey--text">{{ icon_payment_type }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Pagamento Total (Juntos + Concessionária)</v-list-tile-sub-title
            >
            <v-list-tile-title
              >R$
              {{
                (Number(billing.total) +
                  (billing.cemig_value_included
                    ? 0
                    : Number(billing.total_invoice)))
                  | formatCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <!-- Valor Provisionado -->
        <v-list-tile
          avatar
          class="v-list-item"
          v-if="billing.total_provisioned"
        >
          <v-list-tile-action>
            <v-icon class="yellow--text">{{ icon_payment_type }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Valor Provisionado</v-list-tile-sub-title>
            <v-list-tile-title
              >R$
              {{
                billing.total_provisioned | formatCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <!-- Imposto PIS/PASEP -->
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="red--text">money_off</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >PASEP/COFINS Energia Limpa</v-list-tile-sub-title
            >
            <v-list-tile-title
              >R$ {{ billing.tax | formatCurrency }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- { title: 'R$ 54,00', icon: 'stars', iconClass: 'success--text', subtitle: 'Economia' }, -->

        <!-- Desconto -->
        <v-list-tile avatar class="v-list-item" style="height: 72px">
          <v-list-tile-action>
            <v-icon class="green--text">redeem</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Desconto Plano
              {{ billing.percentage_discount }}%</v-list-tile-sub-title
            >
            <v-list-tile-title
              v-if="billing.lost_discount"
              style="height: 52px; line-height: 21px"
            >
              <span style="text-decoration: line-through"
                >R$
                {{
                  (billing.tarifa * (Number(billing.percentage_discount) / 100))
                    | formatCurrency
                }} </span
              ><br /><span
                >R$
                {{
                  (billing.overdue_discount - billing.referral_balance)
                    | formatCurrency
                }}</span
              >
            </v-list-tile-title>
            <v-list-tile-title v-else
              >R$
              {{
                (billing.tarifa * (Number(billing.percentage_discount) / 100))
                  | formatCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>

        <!-- Indicação -->
        <v-list-tile
          avatar
          class="v-list-item"
          v-if="billing.referral_balance > 0"
        >
          <v-list-tile-action>
            <v-icon class="success--text">person</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Indicação de Amigos</v-list-tile-sub-title>
            <v-list-tile-title
              >R$
              {{ billing.referral_balance | formatCurrency }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>

        <!-- Economia -->
        <v-list-tile avatar class="v-list-item" style="height: 72px">
          <v-list-tile-action>
            <v-icon class="success--text">stars</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Economia</v-list-tile-sub-title>
            <v-list-tile-title
              v-if="billing.lost_discount"
              style="height: 52px; line-height: 21px"
            >
              <span style="text-decoration: line-through"
                >R$ {{ economia | formatCurrency }} </span
              ><br /><span
                >R$ {{ billing.overdue_discount | formatCurrency }}</span
              >
            </v-list-tile-title>
            <v-list-tile-title v-else
              >R$ {{ economia | formatCurrency }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-divider />
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="grey--text">star_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Sem Juntos</v-list-tile-sub-title>
            <v-list-tile-title
              >R$
              {{
                billing.total_utility_company | formatCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar class="v-list-item" style="height: 72px">
          <v-list-tile-action>
            <v-icon class="green--text">star</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>Com Juntos</v-list-tile-sub-title>
            <v-list-tile-title
              v-if="billing.lost_discount"
              style="height: 52px; line-height: 21px"
            >
              <span style="text-decoration: line-through"
                >R$
                {{
                  (Number(billing.total) +
                    (billing.cemig_value_included
                      ? 0
                      : Number(billing.total_invoice)))
                    | formatCurrency
                }} </span
              ><br /><span
                >R$
                {{
                  (Number(billing.total_without_discount) +
                    (billing.cemig_value_included
                      ? 0
                      : Number(billing.total_invoice)))
                    | formatCurrency
                }}
              </span>
            </v-list-tile-title>
            <v-list-tile-title v-else
              >R$
              {{
                (Number(billing.total) +
                  (billing.cemig_value_included
                    ? 0
                    : Number(billing.total_invoice)))
                  | formatCurrency
              }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-divider pb-3 />
        <!-- Açoes -->
        <div pt-5 class="text-xs-center">
          <v-tooltip bottom v-if="canInformPayment">
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                color="teal"
                v-on="on"
                v-if="
                  [
                    'overdue',
                    'canceled',
                    'waiting_payment',
                    'pending_approval',
                  ].includes(billing.status)
                "
                @click.stop="dialog_inform_payment = true"
                class="round"
              >
                <v-icon large dark>mdi-arrow-up-bold-box-outline</v-icon>
              </v-btn>
            </template>
            <span>Informar baixa manualmente</span>
          </v-tooltip>
          <v-tooltip bottom v-if="canInformPayment">
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                color="teal"
                v-on="on"
                v-if="
                  billing.status !== 'paid' && billing.status !== 'in_queue'
                "
                @click.stop="dialog_will_pay = true"
                class="round"
              >
                <v-icon large dark>assignment_turned_in</v-icon>
              </v-btn>
            </template>
            <span>Informar que o membro irá realizar o pagamento</span>
          </v-tooltip>
          <v-tooltip v-if="canReprocessing" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                color="red"
                v-on="on"
                v-if="
                  billing.status != 'paid' &&
                  billing.status != 'succeeded' &&
                  billing.status != 'paga' &&
                  billing.status != 'free' &&
                  billing.status != 'refunded' &&
                  billing.status != 'chargedbillingack' &&
                  billing.status != 'reprocessing' &&
                  billing.status != 'in_queue' &&
                  billing.status != 'negotiated' &&
                  billing.status != 'parceled' &&
                  billing.status != 'overdue' &&
                  billing.status != 'waiting_payment'
                "
                @click.stop="dialog = true"
                class="round"
              >
                <v-icon large dark>cached</v-icon>
              </v-btn>
            </template>
            <span>Reprocessar o faturamento sem mudanças.</span>
          </v-tooltip>

          <!-- Reprocessamento com mudanças -->
          <v-tooltip v-if="canReprocessing" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                color="orange"
                v-on="on"
                v-if="
                  billing.status != 'paid' &&
                  billing.status != 'succeeded' &&
                  billing.status != 'paga' &&
                  billing.status != 'postponed'
                "
                @click.stop="
                  dialog_reprocessing = true;
                  charges_description = '';
                "
                class="round"
              >
                <v-icon large dark>published_with_changes</v-icon>
              </v-btn>
            </template>
            <span>Reprocessar o faturamento com mudanças.</span>
          </v-tooltip>
          <!-- FIM Reprocessamento com mudanças -->

          <!-- Desmembrar fatura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                color="orange"
                v-on="on"
                v-if="
                  billing.status != 'paid' &&
                  billing.status != 'succeeded' &&
                  billing.status != 'paga' &&
                  billing.status != 'postponed' &&
                  billing.unique_billing
                "
                @click.stop="confirmBillingDismember(billing)"
                class="round"
              >
                <v-icon large dark>scoreboard</v-icon>
              </v-btn>
            </template>
            <span>Desmembrar fatura</span>
          </v-tooltip>
          <!-- FIM Desmembrar fatura-->

          <v-tooltip bottom v-if="isAdmin">
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                color="teal"
                v-on="on"
                v-if="
                  billing &&
                  billing.transaction &&
                  billing.transaction.id &&
                  billing.payment_service === 'pagarme' &&
                  billing.status !== 'paid'
                "
                @click.prevent="
                  updateBilling(billing.id, billing.transaction.id)
                "
                class="round"
              >
                <v-icon large>find_replace</v-icon>
              </v-btn>
            </template>
            <span>Atualizar a transação conforme Pagar.me.</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                color="blue darken-1"
                v-if="billing.bucket_path || billing.dadosCemig"
                @click="
                  downloadResumePdf(billing.bucket_path, billing.process_type)
                "
                class="round"
              >
                <v-icon large>receipt_long</v-icon>
              </v-btn>
            </template>
            <span>Conta da Concessionária</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                color="blue"
                v-if="billing.invoice_base64"
                @click="dialog_pdf_demonstrativo = true"
                class="round"
              >
                <v-icon large>receipt</v-icon>
              </v-btn>
              <v-btn
                v-on="on"
                fab
                color="blue"
                v-else-if="billing.invoice_url"
                :href="billing.invoice_url"
                target="_blank"
                class="round"
              >
                <v-icon large>receipt</v-icon>
              </v-btn>
            </template>
            <span>Demonstrativo</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                color="green"
                v-if="
                  !billing.transaction?.paid_at &&
                  billing.informed_payment_date &&
                  billing.informed_receipt_url
                "
                :href="billing.informed_receipt_url"
                class="round"
                target="_blank"
              >
                <v-icon large>receipt</v-icon>
              </v-btn>
            </template>
            <span>Comprovante de Baixa Manual</span>
          </v-tooltip>
          <v-tooltip v-if="billing.receipt_url" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                color="orange"
                :href="billing.receipt_url"
                target="_blank"
                class="round"
              >
                <v-icon large>receipt</v-icon>
              </v-btn>
            </template>
            <span>Recibo de Pagamento</span>
          </v-tooltip>
          <v-tooltip
            v-if="
              regenerateInvoiceRules(billing) && permissions.regenerate_billing
            "
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                color="pink lighten-2"
                @click.stop="regenerateInvoice(billing.id)"
                class="round"
              >
                <v-icon large>history</v-icon>
              </v-btn>
            </template>
            <span>Regerar Demonstrativo</span>
          </v-tooltip>
        </div>
        <v-divider />
        <v-list-tile avatar class="v-list-item">
          <v-list-tile-action>
            <v-icon class="green--text">notifications_active</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="font-weight-bold"
              >Comunicados</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
      </v-flex>
      <communication-billing v-if="billing.id" :billing_id="billing.id" />
    </v-navigation-drawer>
    <v-dialog v-model="dialog_will_pay" max-width="550px" persistent>
      <v-form ref="willPay">
        <v-card>
          <v-card-title class="headline grey lighten-2"
            >Pagamento será efetuado</v-card-title
          >
          <v-card-text>
            Marcar que membro não irá ser cobrado automaticamente nos próximos
            dias selecionados.
            <v-dialog
              ref="wpdateDialog"
              v-model="willPayModal"
              :return-value.sync="willPayDate"
              persistent
              lazy
              full-width
              width="450px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="willPayDate"
                  label="Irá pagar até"
                  prepend-icon="date_range"
                  readonly
                  v-on="on"
                  :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                ></v-text-field>
              </template>
              <v-date-picker
                dark
                v-model="willPayDate"
                scrollable
                width="450px"
                :min="new Date().toISOString()"
                :max="
                  new Date(
                    new Date().setDate(new Date().getDate() + 15),
                  ).toISOString()
                "
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="willPayModal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="$refs.wpdateDialog.save(willPayDate)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog_will_pay = false">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              flat
              @click="saveWillPay"
              :disabled="loadingDialog"
              :loading="loadingDialog"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_inform_payment" max-width="550px" persistent>
      <v-form ref="informPayment">
        <v-card>
          <v-card-title class="headline grey lighten-2"
            >Baixa Manual</v-card-title
          >
          <v-card-text>
            Informe a data de pagamento e carregue um comprovante que mostre que
            o pagamento já foi realizado há mais de 3 dias úteis
            <v-dialog
              ref="pdateDialog"
              v-model="paymentDateModal"
              :return-value.sync="paymentDate"
              persistent
              lazy
              full-width
              width="450px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="paymentDate"
                  label="Pagou em"
                  prepend-icon="date_range"
                  readonly
                  v-on="on"
                  :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                ></v-text-field>
              </template>
              <v-date-picker
                dark
                v-model="paymentDate"
                scrollable
                width="450px"
                :max="
                  new Date(
                    new Date().setDate(new Date().getDate()),
                  ).toISOString()
                "
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="paymentDateModal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="$refs.pdateDialog.save(paymentDate)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
            <v-text-field
              v-model="paymentValue"
              label="Valor Pago"
              prepend-icon="mdi-barcode"
              :rules="[rules.required, rules.onlyNumbers]"
              @blur="convertToNumber"
            ></v-text-field>
            <v-text-field
              label="Comprovante"
              @click="onPickFile"
              v-model="filename"
              prepend-icon="attach_file"
            >
            </v-text-field>
            <input
              style="display: none"
              accept="image/*, application/pdf"
              @change="detectFiles($event)"
              type="file"
              ref="receiptFile"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog_inform_payment = false">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              flat
              @click="saveInformPayment"
              :disabled="loadingDialog"
              :loading="loadingDialog"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="headline">Reprocessar a fatura?</v-card-title>

        <v-card-text>
          Esse processo executará o faturamento do membro. Você pode selecionar
          um cartão específico se desejar.

          <v-flex>
            <v-select
              :items="cards"
              v-model="reprocess_card_id"
              :item-text="cardText"
              :item-value="cardValue"
              label="Cartão"
              hint="Selecione o cartão para reprocessar"
              clearable
            ></v-select>
            {{
              !reprocess_card_id
                ? "Irá usar cartão padrão!"
                : "Irá usar: " + reprocess_card_id
            }}
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="dialog = false">
            Não
          </v-btn>

          <v-btn color="red darken-1" flat="flat" @click="faturar(billing.id)">
            Faturar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de reprocessamento -->
    <v-dialog v-model="dialog_reprocessing" max-width="1000" persistent>
      <v-form ref="reprocessing_form">
        <v-card class="pb-2">
          <v-card-title class="headline"
            >Reprocessamento de Fatura</v-card-title
          >
          <v-card-text>
            Insira os dados para recalcular o valor da fatura
            <v-container>
              <v-flex sm12>
                <v-text-field
                  :label="
                    billing.is_cancel_billing
                      ? 'Saldo Acumulado Juntos'
                      : 'Energia Injetada (kWh)'
                  "
                  v-model.number="amount_kW"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor informe a quantidade de energia injetada.',
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  label="Valor do kWh (R$)"
                  v-model="energy_kWh_value"
                  :rules="[(v) => !!v || 'Por favor informe o valor do kWh.']"
                  @blur="energy_kWh_value = formatSixDecimals(energy_kWh_value)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!billing.is_cancel_billing">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="black"
                      size="16"
                      v-on="on"
                      icon
                      style="cursor: default"
                      class="mr-1"
                      >mdi-alert-circle-outline</v-icon
                    >
                  </template>
                  <div>
                    <p class="font-weight-bold">
                      Compreende o total de saldo na instalação, podendo ser da
                      Juntos Energia ou de outra fonte de recebimento. Ex: UC
                      com geração própria
                    </p>
                  </div>
                </v-tooltip>
                <v-text-field
                  label="Saldo da UC na Concessionária"
                  v-model.number="balance"
                  @blur="balance = formatInteger(balance)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!billing.is_cancel_billing">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="black"
                      size="16"
                      v-on="on"
                      icon
                      style="cursor: default"
                      class="mr-1"
                      >mdi-alert-circle-outline</v-icon
                    >
                  </template>
                  <div>
                    <p class="font-weight-bold">
                      Compreende apenas o saldo injetado pela Juntos, o saldo
                      acumulado pode ser cobrado no fim de faturamento ou na
                      fatura de encerramento após análise do time de faturamento
                    </p>
                  </div>
                </v-tooltip>
                <v-text-field
                  label="Saldo Acumulado Juntos"
                  v-model.number="juntos_balance"
                  @blur="juntos_balance = formatInteger(juntos_balance)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!billing.is_cancel_billing">
                <v-text-field
                  label="Consumo (kWh)"
                  v-model="energy_kWh"
                  @blur="energy_kWh = formatTwoDecimalsOrInteger(energy_kWh)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  label="Impostos PIS/COFINS (R$)"
                  v-model="tax"
                  @blur="tax = formatTwoDecimals(tax)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  label="Bonus (R$)"
                  v-model="account_balance"
                  @blur="account_balance = formatTwoDecimals(account_balance)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!billing.is_cancel_billing">
                <v-text-field
                  label="Valor da Concessionária"
                  v-model="total_invoice"
                  @blur="total_invoice = formatTwoDecimals(total_invoice)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  label="Juros e Multas (R$)"
                  v-model="juros_multas"
                  @blur="juros_multas = formatTwoDecimals(juros_multas)"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  label="Valor Total da Fatura (R$)"
                  v-model.number="total"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select
                  :items="payment_type_items"
                  item-value="value"
                  item-text="text"
                  label="Método de Pagamento"
                  v-model="payment_type"
                  :rules="[
                    (v) => !!v || 'Por favor, informe o método de pagamento',
                  ]"
                  required
                >
                </v-select>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="due_date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  dark
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="due_date"
                      label="Nova Data de Vencimento"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :rules="[
                        (v) =>
                          !!v || 'Por favor informe a nova data de vencimento.',
                        (v) =>
                          v >= minDate ||
                          'Data de vencimento deve ser maior ou igual a 5 dias da data atual.',
                        (v) =>
                          v <= maxDate ||
                          'Data de vencimento deve ser menor ou igual a 30 dias da data atual.',
                      ]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="due_date"
                    no-title
                    scrollable
                    :min="minDate"
                    :max="maxDate"
                    :allowed-dates="allowedDates"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menu = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.menu.save(due_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-switch
                v-model="checkbox_unique_billing"
                label="Cobrar Conta da Concessionária"
              ></v-switch>
              <v-switch
                v-model="checkbox_return_discount"
                label="Devolver desconto perdido (Planos Especiais)"
              ></v-switch>
              <v-switch
                v-model="checkbox_tax"
                label="Cobrar Impostos PIS/COFINS"
              ></v-switch>
              <v-switch
                v-model="checkbox_calculateFees"
                label="Calcular automaticamente Juros e Multas"
              ></v-switch>
              <v-switch
                v-if="!billing.is_cancel_billing"
                v-model="checkbox_applyJuntosBalance"
                label="Cobrar saldo Juntos da UC"
              ></v-switch>
              <v-flex sm12>
                <v-textarea
                  v-model="charges_description"
                  label="Descrição das Cobranças"
                ></v-textarea>
              </v-flex>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="red darken-1"
              flat="flat"
              @click="dialog_reprocessing = false"
              :disabled="loading"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="blue darken-1"
              flat="flat"
              :loading="loading"
              :disabled="!permissions.reprocess_billing"
              @click="reprocessing(billing.id, false)"
            >
              Recalcular
            </v-btn>

            <v-btn
              color="green darken-1"
              flat="flat"
              :loading="loading"
              :disabled="!permissions.reprocess_billing"
              @click="reprocessing(billing.id, true)"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <recalculos-fatura />
    <!-- Fim Dialog de reprocessamento -->

    <v-dialog v-model="dialog_pdf_conta" max-width="800px">
      <v-card>
        <template>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog_pdf_conta = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="imprimir($refs.pdfConta)"
                >Imprimir</v-btn
              >
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <pdf ref="pdfConta" :src="conta"></pdf>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>

    <!-- Dialog que mostra a conta da CEMIG criada pela juntos -->
    <v-dialog v-model="dialog_dados_cemig">
      <v-card>
        <v-card-title class="cemig-title">
          <h3>Conta da CEMIG</h3>
          <v-spacer />
          <v-btn class="cemig-button" @click="dialog_dados_cemig = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container v-if="billing.dadosCemig">
            <v-row class="d-flex">
              <v-col class="d-flex column borda" cols="12" md="6">
                <span class="align-self-center font-weight-bold">{{
                  billing.user?.name || ""
                }}</span>
                <v-col class="d-flex wrap column">
                  <span
                    ><b>N° do cliente:</b>
                    {{ billing.dadosCemig.numero_cliente }}</span
                  >
                  <span
                    ><b>N° da instalação:</b>
                    {{ billing.dadosCemig.numero_instalacao }}</span
                  >
                  <div
                    v-if="billing.dadosCemig?.informacoes_tecnicas[0]?.consumo"
                  >
                    <b>Consumo kWh:</b>
                    {{ billing.dadosCemig.informacoes_tecnicas[0].consumo }}
                  </div>
                  <div class="d-flex wrap borda" cols="12" md="6">
                    <span class="align-self-center"
                      ><b>Referente a:</b> {{ billing.competence }}</span
                    >
                    <span class="align-self-center"
                      ><b>Vencimento:</b>
                      {{
                        billing.dadosCemig.vencimento | formatStringToDate
                      }}</span
                    >
                    <span class="align-self-center"
                      ><b>Valor a pagar (R$):</b>
                      {{
                        billing.dadosCemig.valor_a_pagar | formatXMLValue
                      }}</span
                    >
                    <span class="align-self-center"
                      ><b>Data da emissão:</b>
                      {{
                        billing.dadosCemig.emissao | formatStringToDate
                      }}</span
                    >
                  </div>
                  <div class="d-flex wrap borda">
                    <span class="align-self-center"
                      ><b>Classe:</b> {{ billing.dadosCemig.classe }}</span
                    >
                    <span class="align-self-center"
                      ><b>Subclasse:</b>
                      {{ billing.dadosCemig.subclasse }}</span
                    >
                    <span class="align-self-center"
                      ><b>Modalidade tarifária:</b>
                      {{ billing.dadosCemig.modalidade_tarifaria }}</span
                    >
                    <div class="d-flex column">
                      <b class="align-self-center">Datas da leitura</b>
                      <div class="d-flex">
                        <span
                          ><b>Anterior:</b>
                          {{
                            billing.dadosCemig.leitura_anterior
                              | formatStringToDate
                          }}</span
                        >
                        <span
                          ><b>Atual:</b>
                          {{
                            billing.dadosCemig.leitura_atual
                              | formatStringToDate
                          }}</span
                        >
                        <span
                          ><b>Próxima:</b>
                          {{
                            billing.dadosCemig.leitura_proxima
                              | formatStringToDate
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="d-flex column borda">
                    <b class="align-self-center">Valores Faturados</b>
                    <v-data-table
                      :headers="headersDadosConta"
                      :items="billing.dadosCemig.valores_faturados"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.descricao }}</td>
                        <td class="text-xs-left">
                          {{ props.item.quantidade }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.tarifa_preco }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.valor | formatXMLValue }}
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                  <div class="d-flex column borda">
                    <b class="align-self-center">Informações Gerais</b>
                    <!-- Ainda não é salvo esse dado no xml -->
                    <p>{{ billing.dadosCemig.informacoes_gerais }}</p>
                  </div>
                  <v-row class="d-flex borda">
                    <span
                      ><b>Código de barras:</b>
                      {{
                        billing.dadosCemig ? billing.dadosCemig.boleto : ""
                      }}</span
                    >
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fim Dialog que mostra a conta da CEMIG criada pela juntos -->

    <v-dialog v-model="dialog_pdf_demonstrativo" max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog_pdf_demonstrativo = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="imprimir($refs.pdfDemonstrativo)"
              >Imprimir</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <pdf ref="pdfDemonstrativo" :src="demonstrativo"></pdf>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { firestorage } from "@/firebase/firestorage";
import { standardBucket } from "@/firebase/firestorageBank";
import axios from "axios";
import firebase from "firebase";
import moment from "moment";
import pdf from "vue-pdf";
import { mapActions, mapGetters, mapState } from "vuex";
import CommunicationBilling from "../../components/faturaDetails/CommunicationBilling.vue";
import firestore from "../../firebase/firestore";
import { eventBus } from "../../main";
import { calendarMixin } from "../../mixin/calendarMixin";
import { recalcInvoice, updateBilling } from "../../services/billing";
import { getTransaction } from "../../services/pagarme";
import { getPermission } from "../../services/permissions";
import RecalculosFatura from "./RecalculosFatura.vue";

export default {
  name: "DetalhesFatura",
  components: {
    pdf,
    CommunicationBilling,
    RecalculosFatura,
  },
  mixins: [calendarMixin],

  data: () => ({
    logo: "../../img/newJuntos_logo_color.png",
    partner: "enercred",
    showDrawer: false,
    billing_id: "",
    billing: {},
    renegotiationDeleteID: "",
    renegotiationDeleteResponse: {},
    renegotiationWasDeleted: false,
    juros_multas: "",
    error: "",
    energy_kWh: 0,
    right: false,
    responsive: false,
    loading: false,
    loadingDialog: false,
    dialog: false,
    dialog_pdf_conta: false,
    dialog_pdf_demonstrativo: false,
    dialog_will_pay: false,
    dialog_inform_payment: false,
    filename: "",
    currentFile: null,
    receiptFile: null,
    paymentDate: "",
    paymentValue: null,
    willPayDate: "",
    willPayModal: false,
    paymentDateModal: false,
    color: "",
    snackMessage: "",
    snackbar: false,
    dialog_reprocessing: false,
    amount_kW: 0,
    balance: 0,
    juntos_balance: 0,
    discount: 0,
    energy_kWh_value: 0,
    custo_disp: 0,
    tax: 0,
    payment_type_items: [
      { text: "Cartão de Crédito", value: "credit_card" },
      { text: "Boleto", value: "boleto" },
      { text: "Pix", value: "pix" },
    ],
    payment_type: "",
    total: 0,
    account_balance: 0,
    total_invoice: null,
    change_description: "",
    charges_description: null,
    checkbox_unique_billing: false,
    checkbox_return_discount: false,
    checkbox_tax: false,
    checkbox_calculateFees: false,
    checkbox_applyJuntosBalance: false,
    menu: false,
    due_date: null,
    reprocess_card_id: null,
    duplicated_payment_total: 0,
    duplicated_payment_desc: "",
    dialog_dados_cemig: false,
    headersDadosConta: [
      { text: "Itens da Fatura", value: "string" },
      { text: "Quant. (kWh)", value: "number" },
      { text: "Preço Unit", value: "initValue" },
      { text: "Valor (R$)", value: "value" },
    ],
    rules: {
      required: (v) => !!v || "Campo obrigatório",

      onlyNumbers: (v) => {
        if (typeof v !== "string" && typeof v !== "number") {
          return "O valor só pode conter números, vírgulas ou pontos!";
        }
        const value = String(v).replace(",", "."); // Garante que seja string
        return (
          !!value.match(/^\d+([.,]\d+)?$/) ||
          "O valor só pode conter números, vírgulas ou pontos!"
        );
      },
    },
  }),
  created() {
    let vm = this;
    vm.loading = true;
    const date = new Date();
    date.setDate(date.getDate() + 5);
    this.due_date = date.toISOString().substring(0, 10);
    eventBus.$on("right", function (value) {
      vm.right = value;
    });
    eventBus.$on("billing_id", function (value) {
      this.billing_id = value;
      firestore
        .collection("billing")
        .doc(value)
        .onSnapshot(async (res, error) => {
          if (error || !res.data() || !res.data().customer_id) {
            console.error("Erro ao pegar os dados", error);
            console.error("Erro ao pegar os dados2: ", res.data());
            vm.loading = false;
          }
          const user = await firestore
            .collection("users")
            .doc(res.data().customer_id)
            .get();
          let conta = "";
          if (res.data().bill) {
            const bill = await firestore
              .collection("bills")
              .doc(res.data().bill.id)
              .get();
            if (bill.id) {
              conta = bill.data().base64;
            }
          } else if (
            res.data() &&
            res.data().bills &&
            res.data().bills.length > 0
          ) {
            conta = res.data().bills[0].base64String;
          }

          const dadosCemig = await firestore
            .collection("invoices_xml")
            .doc(`${res.data().consumer_unit}_${res.data().competence}`)
            .get();

          const billing = {
            id: res.id,
            ...res.data(),
            user: user.data(),
            conta: conta,
          };

          if (dadosCemig.exists) {
            billing.dadosCemig = dadosCemig.data();
          }

          vm.billing = billing;
          if (billing && billing.payment_type)
            vm.payment_type = billing.payment_type;
          else if (billing && billing.transaction)
            vm.payment_type = billing.transaction.payment_method;
          else if (billing.user) vm.payment_type = billing.user.payment_type;
          vm.amount_kW = billing.amount_kW;
          vm.energy_kWh_value = billing.energy_kWh_value;
          vm.energy_kWh = billing.energy_kWh;
          vm.balance = billing.balance || 0;
          vm.custo_disp = billing.custo_disp || 0;
          vm.tax = billing.tax || 0;
          vm.discount = billing.discount;
          vm.account_balance = billing.account_balance || 0;
          vm.total_invoice = billing.total_invoice || 0;
          vm.due_date = vm.due_date || date.toISOString().substring(0, 10);
          vm.total = billing.total;
          vm.loading = false;
        });
    });
  },
  mounted() {
    this.getCardsByUser(this.userCS.cards);
  },

  watch: {
    right: function (val) {
      if (!val) {
        this.billing = {};
        this.billing_id = "";
        this.loading = true;
      }
    },
  },

  methods: {
    ...mapActions("cs", ["getCardsByUser"]),
    onPickFile() {
      this.$refs.receiptFile.click();
    },

    convertToNumber() {
      if (this.paymentValue) {
        const value = String(this.paymentValue).replace(",", ".");
        const numericValue = parseFloat(value);
        if (!isNaN(numericValue)) {
          this.paymentValue = numericValue; // Garante que o valor seja do tipo Number
        } else {
          this.paymentValue = ""; // Reseta o valor em caso de entrada inválida
        }
      }
    },

    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map((x) => {
        this.currentFile = fileList[x];
      });
      this.filename = this.currentFile.name;
    },
    showRecalcBilling(billing) {
      let value = {
        show: true,
        value: billing,
      };
      eventBus.$emit("getChangesBilling", value);
    },
    async uploadFile(file) {
      try {
        console.log("start uploading file: ", file);
        if (file && file.name) {
          const filePath = `comprovantes/${file.name}`;
          const metadata = { contentType: file.type };
          let uploadTask = standardBucket
            .ref()
            .child(filePath)
            .put(file, metadata);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              let progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log("Upload is " + progress + "% done");
              switch (snapshot.state) {
                case firebase.storage.TaskEvent.PAUSED:
                  console.log("Upload is paused");
                  break;
                case firebase.storage.TaskEvent.RUNNING: // or 'running'
                  console.log("Upload is running");
                  break;
              }
            },
            (error) => {
              switch (error.code) {
                case "storage/unauthorized":
                  this.snack(
                    "Não há autorização para o upload do arquivo.",
                    "red",
                  );
                  break;
                case "storage/canceled":
                  this.snack("Upload cancelado.", "red");
                  break;
                case "storage/unknown":
                  this.snack(
                    "Ocorreu um erro inesperado, tente novamente.",
                    "red",
                  );
                  break;
              }
            },
            async () => {
              //Upload completed
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(async (downloadURL) => {
                  console.log("File available at", downloadURL);
                  const update_data = {
                    status: "paid",
                    updated_at: new Date(),
                    informed_payment_date: this.paymentDate,
                    transaction: {
                      ...this.billing.transaction,
                      paid_amount: this.paymentValue * 100,
                    },
                    informed_receipt_url: downloadURL,
                    payment_informed_by: this.user.email,
                    payment_informed_at: new Date(),
                  };
                  await updateBilling(this.billing.id, update_data)
                    .then(() => {
                      this.dialog_inform_payment = false;
                      this.loadingDialog = false;
                      this.snack("Baixa manual efetuada com sucesso!", "green");
                    })
                    .catch((err) => {
                      this.dialog_inform_payment = false;
                      this.loadingDialog = false;
                      this.snack("Erro ao sallet. " + err, "top", "red");
                      console.error(err);
                    });
                });
            },
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    async faturar(id) {
      try {
        this.loading = true;
        const permission = await getPermission("faturar", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.loading = false;
          return false;
        }
      } catch (err) {
        this.loading = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      let vm = this;
      vm.dialog = false;
      vm.right = true;
      const newBilling = {
        updated_at: new Date(),
        status: "reprocessing",
        payment_type: "credit_card",
        card_id: this.reprocess_card_id || null,
      };
      firestore
        .collection("billing")
        .doc(id)
        .update(newBilling)
        .then(() => {
          vm.loading = false;
          this.snack(
            "Sistema refaturando. Aguarde alguns segundos...",
            "success",
          );
        })
        .catch((err) => {
          vm.loading = false;
          console.error(err);
          this.snack("Erro ao iniciar o refaturamento!", "error");
        });
    },
    minTimeReprocess(billing_date, ms) {
      if (!billing_date) return true;
      if (typeof billing_date === "string") {
        if (billing_date.split("/").length > 1) {
          if (billing_date.split("/")[0].length > 2) {
            billing_date = moment(billing_date, "YYYY/MM/DD");
          } else billing_date = moment(billing_date, "DD/MM/YYYY");
        }
        return new Date(billing_date);
      } else if (typeof billing_date === "object") {
        if (billing_date._seconds)
          billing_date = new Date(billing_date._seconds * 1000);
        else if (billing_date.seconds)
          billing_date = new Date(billing_date.seconds * 1000);
        else return undefined;
      }
      let start_date = new Date(billing_date).getTime();
      let end_date = new Date().getTime();
      let diff = end_date - start_date;
      return diff > ms;
    },
    castNumber(value) {
      if (typeof value == "string") return Number(value.replace(",", "."));
      return value;
    },

    formatUtility(value) {
      if (value === "cemig" || !value) {
        return "Cemig";
      } else if (value === "cpfl-piratininga") {
        return "CPFL";
      } else if (value === "neoenergia-pe") {
        return "Neoenergia";
      }
      return value;
    },

    async reprocessing(id, save) {
      this.change_description = "";
      if (!this.$refs["reprocessing_form"].validate()) {
        return false;
      }

      let vm = this;
      vm.dialog = false;
      vm.right = true;
      vm.loading = true;

      try {
        const permission = await getPermission(
          "reprocess_billing",
          this.user.id,
        );

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          vm.loading = false;
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        vm.loading = false;
        return false;
      }

      const recalcData = {
        consumer_unit: this.billing.consumer_unit,
        billing_id: id,
        save: save,
        amount_kW: this.castNumber(vm.amount_kW),
        energy_kWh_value: this.castNumber(vm.energy_kWh_value),
        custo_disp: this.castNumber(vm.custo_disp),
        tax: this.castNumber(vm.tax),
        account_balance: this.castNumber(vm.account_balance),
        total_invoice: vm.total_invoice
          ? this.castNumber(vm.total_invoice)
          : null,
        juros_multas:
          vm.juros_multas.length > 0 ? this.castNumber(vm.juros_multas) : null,
        referral_balance: this.billing.referral_balance || null,
        payment_type: this.payment_type,
        due_date: vm.due_date || null,
        checkbox_tax: this.checkbox_tax,
        return_discount: this.checkbox_return_discount,
        checkbox_calculateFees: this.checkbox_calculateFees,
        checkbox_unique_billing: this.checkbox_unique_billing,
        checkbox_applyJuntosBalance: this.checkbox_applyJuntosBalance,
        in_invoice_sending_queue: false,
        utility_company: this.billing.utility_company,
        balance: vm.balance,
        juntos_balance: this.juntos_balance,
        duplicated_payment_total: this.castNumber(vm.duplicated_payment_total),
        duplicated_payment_desc: vm.duplicated_payment_desc,
        energy_kWh: this.castNumber(vm.energy_kWh),
        agent_email: this.user.email,
        agent_id: this.user.id,
        competence: this.billing.competence,
      };

      recalcInvoice(recalcData)
        .then((res) => {
          if (res.status !== 200) {
            if (res.data?.message) {
              this.snack(res.data?.message, "red");
            } else {
              this.snack(
                `Ocorreu um erro ao ${
                  save ? "iniciar" : "simular"
                } o faturamento`,
                "red",
              );
            }
            vm.loading = false;
            return false;
          }

          if (save) {
            this.snack(
              "Sistema refaturando. Aguarde alguns segundos...",
              "success",
            );
            vm.dialog_reprocessing = false;
            this.charges_description = "";
          } else {
            const newBilling = res.data;
            this.charges_description = "";
            newBilling.charges.forEach((c) => {
              this.charges_description += `${c.ref}: R$ ${c.value
                .toFixed(2)
                .replace(".", ",")}\n`;
            });
            this.charges_description += `\nTotal da Fatura: R$ ${newBilling.total
              .toFixed(2)
              .replace(".", ",")}`;
            this.total = newBilling.total;
          }
        })
        .catch((err) => {
          vm.loading = false;
          console.error(err);
          if (err.response) {
            console.error(err.response);
          }
          if (err.response?.data?.message) {
            this.snack(err.response?.data?.message, "red");
          } else {
            this.snack(
              `Ocorreu um erro ao ${
                save ? "iniciar" : "simular"
              } o faturamento`,
              "red",
            );
          }
        });

      vm.loading = false;
      return true;
    },

    updateBilling(billing_id, transaction_id) {
      let vm = this;
      vm.loading = true;
      getTransaction(transaction_id)
        .then((transaction) => {
          if (transaction.status === 200) {
            const newTransaction = {
              updated_at: new Date(),
              status: transaction.data.status,
              transaction: transaction.data,
            };
            firestore
              .collection("billing")
              .doc(billing_id)
              .update(newTransaction)
              .then(() => {
                this.snack(
                  "Transação atualizada conforme o pagarme...",
                  "success",
                );
                vm.loading = false;
                // vm.right = true
              })
              .catch((error) => {
                console.error("Erro ao atualizar a transação: ", error);
                this.snack("Erro ao atualizar a transação!", "error");
                vm.loading = false;
              });
          }
        })
        .catch((error) => {
          console.error("Erro ao recuperar transação: ", error);
          this.snack("Erro ao recuperar transação!", "error");
          vm.loading = false;
        });
    },
    regenerateInvoiceRules(billing) {
      return !!(billing.status !== "paid" && billing.status !== "parceled");
    },
    async regenerateInvoice(billingId) {
      this.loading = true;
      try {
        const permission = await getPermission(
          "regenerate_billing",
          this.user.id,
        );

        if (!permission.data.has_permission) {
          this.snack(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loading = false;
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "top", "red");
        console.error("Falha ao consultar permissão", err);
        this.loading = false;
        return false;
      }
      firestore
        .collection("billing")
        .doc(billingId)
        .update({
          regenerate_invoice: true,
          updated_at: new Date(),
        })
        .then(() => {
          this.snack("Demonstrativo está sendo regerado!", "success");
          this.loading = false;
        })
        .catch((error) => {
          this.snack("Erro ao regenerar demonstrativo! " + error, "error");
          this.loading = false;
        });
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    imprimir(ref) {
      ref.print();
    },
    async saveWillPay() {
      if (!this.$refs["willPay"].validate()) {
        return false;
      }
      this.loadingDialog = true;
      await updateBilling(this.billing.id, {
        skip_charge: this.willPayDate,
        updated_at: new Date(),
      })
        .then(() => {
          this.dialog_will_pay = false;
          this.loadingDialog = false;
          this.snack("Salvo com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.dialog_will_pay = false;
          this.loadingDialog = false;
          this.snack("Erro ao sallet. " + err, "top", "red");
          console.error(err);
        });
    },
    async saveInformPayment() {
      if (!this.currentFile) {
        this.snack("Comprovante não carregado", "top", "red");
        return false;
      }
      if (!this.$refs["informPayment"].validate()) {
        return false;
      }
      try {
        const permission = await getPermission("inform_payment", this.user.id);

        if (!permission.data.has_permission) {
          this.snack(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "top", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      this.loadingDialog = true;
      return this.uploadFile(this.currentFile);
    },
    cancelParcels(billingID) {
      this.renegotiationDeleteID = billingID;
      axios
        .get("api/url/")
        .then((response) => {
          this.renegotiationDeleteResponse = response.data;
          this.renegotiationWasDeleted = true;
        })
        .catch(function (err) {
          this.renegotiationDeleteResponse = err.data;
          this.renegotiationWasDeleted = false;
          console.error(
            "ERROR - CANCELAMENTO DA RENEGOCIAÇÃO ::::: " +
              this.renegotiationDeleteResponse,
            this.renegotiationWasDeleted,
          );
        });
    },
    cardText(item) {
      const first = item.data.first_digits;
      const last = item.data.last_digits;
      return `${first.slice(0, 4)} ${first.slice(4, 6)}** **** ${last}`;
    },
    cardValue(item) {
      return item.data.id;
    },
    downloadResumePdf(path, process_type) {
      const resumeRef = firestorage.ref(path);
      resumeRef
        .getDownloadURL()
        .then((url) => {
          window.open(
            url,
            "popup",
            "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800",
          );
        })
        .catch((error) => {
          console.log("Erro ao buscar conta no bucket: ", error.code);
          if (process_type && process_type == "xml")
            this.dialog_dados_cemig = true;
          // Handle any errors
          switch (error.code) {
            case "storage/object-not-found":
              console.log("File doesn't exist");
              break;

            case "storage/unauthorized":
              console.log("User doesn't have permission to access the object");
              break;

            case "storage/canceled":
              console.log("User canceled the upload");
              break;

            case "storage/unknown":
              console.log(
                "Unknown error occurred, inspect the server response",
              );
              break;
            default:
              break;
          }
        });
    },
    confirmBillingDismember(billing) {
      this.$swal({
        title: "Tem certeza que deseja desmembrar essa fatura?",
        text: "Você não poderá desfazer essa ação.",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Não",
        cancelButtonColor: "red",
        confirmButtonColor: "green",
        confirmButtonText: "Sim",
      }).then((result) => {
        // <--
        if (result.value) {
          // <-- if confirmed
          this.dismember(billing);
        }
      });
    },
    dismember(billing) {
      let vm = this;
      vm.dialog = false;
      vm.right = true;
      vm.loading = true;

      if (!billing.unique_billing) {
        vm.loading = false;
        return this.snack(
          "Falha no desmembramento: Não é fatura única.",
          "error",
        );
      }

      //Novo valor e data de vencimento
      const newTotal = billing.lost_discount
        ? billing.total_without_discount - billing.total_invoice
        : billing.total - billing.total_invoice;
      let newDueDate = moment().add(5, "days").format("YYYY-MM-DD");

      const newTotalWithoutDiscount = billing.total_without_discount
        ? newTotal
        : null;

      const newDiscount = billing.lost_discount ? 0 : billing.discount;

      const old_values = {
        due_date: billing.due_date || null,
        amount_kW: billing.amount_kW || null,
        discount: billing.discount || null,
        energy_kWh_value: billing.energy_kWh_value || null,
        total: billing.total || null,
        payment_type: billing.payment_type || billing.user.payment_type,
        account_balance: billing.account_balance || null,
        total_invoice: billing.total_invoice || null,
        invoice_url: billing.invoice_url || null,
        total_without_discount: billing.total_without_discount || null,
      };

      let changes = billing.changes || [];
      changes.push({
        user_id: this.user.id,
        user_email: this.user.email,
        updated_at: new Date(),
        old_values: old_values,
      });

      let newCharges = [];

      billing.charges.forEach((charge) => {
        if (!charge.ref.toLowerCase().startsWith("fatura da")) {
          newCharges.push(charge);
        }
      });

      const billing_update = {
        total: newTotal,
        unique_billing: false,
        updated_at: new Date(),
        split: null,
        due_date: newDueDate,
        changes: changes,
        force_due_date: true,
        status: "reprocessing",
        invoice_url: null,
        transaction: null,
        charges: newCharges,
        discount: newDiscount,
      };

      if (newTotalWithoutDiscount) {
        billing_update.total_without_discount = newTotalWithoutDiscount;
      }

      firestore
        .collection("billing")
        .doc(billing.id)
        .update(billing_update)
        .then(() => {
          vm.loading = false;
          this.snack("Desmembramento realizado com sucesso.", "success");
        })
        .catch((error) => {
          vm.loading = false;
          console.error("Erro ao realizar o desmembramento. ", error);
          this.snack("Erro ao realizar o desmembramento.", "error");
        });
    },
    showError(error) {
      this.$swal({
        title: "Erro!",
        text: error,
        type: "error",
      });
    },
    copyPixCode(link) {
      navigator.clipboard.writeText(link);
      this.snack("Código Pix copiado para área de transferência.", "green");
    },
    calculaValorFaturaAposVenc() {
      let total = this.billing.total;
      let charges = this.billing.charges;
      if (charges) {
        for (const charge of charges) {
          if (charge.ref.startsWith("Desconto Energia Limpa")) {
            total += charge.value * -1;
          }
        }
      }
      return this.billing.total == total ? null : total;
    },

    getJurosMultas() {
      let juros_multas = Array.isArray(this.billing.interest)
        ? this.billing.interest.reduce((acc, item) => acc + item.juros_multa, 0)
        : 0;
      return juros_multas;
    },

    plan20() {
      const specialPlans = [
        "liquidaenergiapf",
        "liquidaenergiapj",
        "cemig_12meses_20to13pf",
        "cemig_12meses_20to13pj",
      ];
      const plan_id = this.consumerUnit.plan?.id;
      return specialPlans.includes(plan_id);
    },

    formatSixDecimals(value) {
      if (value !== null && value !== "") {
        value = value.toString().replace(",", ".");

        const parsedValue = parseFloat(value);
        if (isNaN(parsedValue)) return 0.0;

        const truncatedValue = Math.floor(parsedValue * 1000000) / 1000000;

        return truncatedValue;
      }
      return value;
    },
    formatTwoDecimals(value) {
      if (value !== null && value !== "") {
        value = value.toString().replace(",", ".");

        const parsedValue = parseFloat(value);

        if (isNaN(parsedValue)) return 0.0;

        const truncatedValue = Math.floor(parsedValue * 100) / 100;
        return truncatedValue;
      }
      return value;
    },
    formatTwoDecimalsOrInteger(value) {
      if (value !== null && value !== "") {
        value = value.toString().replace(",", ".");

        const parsedValue = parseFloat(value);
        if (isNaN(parsedValue)) return 0.0;

        if (value % 1 === 0) {
          return parseInt(parsedValue);
        }

        const truncatedValue = Math.floor(parsedValue * 100) / 100;
        return truncatedValue;
      }
      return value;
    },
    formatInteger(value) {
      if (value !== null && value !== "") {
        return parseInt(value);
      }
      return value;
    },
  },

  filters: {
    formatDateTime(value) {
      if (!value || value === "") return "";
      if (typeof value === "string") return moment(value).format("DD/MM/YYYY");
      else return moment(value.toDate()).format("DD/MM/YYYY HH:mm");
    },
    formatCurrency(value) {
      if (!value || value === "") return 0;
      const new_value = Number(value);
      return new_value.toFixed(2).replace(".", ",");
    },
    formatBoletoExp(value) {
      if (!value || value === "") return "";
      if (typeof value === "string") {
        return moment(new Date(value)).utcOffset(3).format("DD/MM/YYYY");
      } else {
        return moment(value.toDate()).format("DD/MM/YYYY");
      }
    },
    formatBalance(value) {
      if (!value || value === "") return "";
      const new_value = Number(value);
      return new_value.toFixed(2).replace(".", ",");
    },
  },
  computed: {
    ...mapState("cs", ["userCS", "activeCards", "loadingCards"]),
    ...mapGetters("cs", ["cards"]),
    ...mapState(["user", "permissions"]),
    consumerUnit() {
      if (this.$store.state && this.$store.state.cs.consumerUnit)
        return this.$store.state.cs.consumerUnit;
      else return null;
    },
    icon_payment_type: function () {
      // alert(this.billing.transaction)
      if (this.billing.transaction) {
        if (this.billing.transaction.payment_method === "credit_card")
          return "payment";
        else if (this.billing.transaction.payment_method === "pix")
          return "qr_code_2";
        else return "mdi-barcode";
      } else {
        return "payment";
      }
    },
    status: function () {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() - 1);

      if (this.billing.status === "") return "xxx";
      else if (this.billing.status === "error") return "Erro";
      else if (
        this.billing.status === "paid" ||
        this.billing.status === "succeeded"
      )
        return "Paga";
      else if (this.billing.status === "pending") return "Processar";
      else if (this.billing.status === "refused") return "Recusada";
      else if (this.billing.status === "reprocessing") return "Reprocessando";
      else if (this.billing.status === "pending_approval") return "Em Análise";
      else if (this.billing.status === "generating") return "Gerando";
      else if (this.billing.status === "opened") return "Aberto";
      else if (this.billing.status === "canceled") return "Expirado";
      else if (this.billing.status === "overdue") return "Atrasada";
      else if (this.billing.status === "generation_failed")
        return "Falha ao gerar";
      else if (this.billing.status === "validation_failed") return "Inválido";
      else if (this.billing.status === "free") return "Abonado";
      else if (this.billing.status === "in_queue") return "Programado";
      else if (this.billing.status === "refunded") return "Reembolsado";
      else if (this.billing.status === "negotiated") return "Negociado";
      else if (this.billing.status === "parceled") return "Parcelado";
      else if (this.billing.status === "waiting_payment") return "Aberta";
      else if (this.billing.status === "free_pending") return "Pend. p/ Abono";
      else if (this.billing.status === "postponed") return "Adiada";
      else return this.billing.status;
    },
    canReprocessing: function () {
      if (this.user) {
        if (this.permissions.reprocess_billing) return true;
        else if (
          (this.user.group.includes("customer_care") ||
            this.user.group == "customer_care") &&
          this.billing.status == "refused"
        ) {
          return this.minTimeReprocess(
            this.billing.transaction.date_updated,
            300000,
          );
        } else return false;
      } else return false;
    },
    canInformPayment: function () {
      if (this.user && this.user.group?.includes("external_collection")) {
        return false;
      }
      if (this.user && this.user.group?.includes("admin")) {
        return true;
      }
      return false;
    },
    isAdmin: function () {
      if (this.user && this.user.group) {
        return this.user.group.includes("admin");
      }
      return false;
    },
    conta: function () {
      if (this.billing && this.billing.conta) {
        return "data:application/pdf;base64," + this.billing.conta;
      } else {
        return "";
      }
    },
    demonstrativo: function () {
      if (this.billing && this.billing.invoice_base64) {
        return "data:application/pdf;base64," + this.billing.invoice_base64;
      } else {
        return "";
      }
    },
    consumo: function () {
      return this.billing.energy_kWh || 0; // + (this.billing.amount_kW || 0)
    },
    economia: function () {
      let parcela = 0;
      if (
        this.billing.installment_info &&
        this.billing.installment_info.installment_sequence &&
        this.billing.installment_info.total_installment
      )
        parcela = this.billing.installment_info.total_installment;
      return (
        Number(this.billing.total_utility_company) -
        (Number(this.billing.total) -
          parcela +
          (this.billing.unique_billing && this.billing.cemig_value_included
            ? 0
            : Number(this.billing.total_invoice)))
      );
    },
    minDate() {
      const date = new Date();
      date.setDate(date.getDate() + 1);
      return date.toISOString();
    },
    maxDate() {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date.toISOString();
    },
  },
};
</script>
<style scoped lang="scss">
.detail-status {
  height: 50px;
  color: #fff;
  // font-size: 15px;
  border-radius: 3px;
  font-weight: 600;
  text-align: center;
  padding: 0px 10px;

  &--paid {
    background-color: #3cb880;
  }

  &--succeeded {
    background-color: #3cb880;
  }

  &--free {
    background-color: #3cb880;
  }

  &--refused {
    background-color: orange;
    color: #fff;
  }

  &--canceled {
    background-color: black;
    color: #fff;
  }

  &--pending {
    background-color: #888;
  }

  &--waiting_payment {
    background-color: #888;
  }

  &--overdue {
    background-color: red;
  }

  &--opened {
    background-color: #888;
  }

  &--reprocessing {
    background-color: #333;
    color: #fff;
  }

  &--atrasada {
    background-color: red;
    color: #fff;
  }

  &--overdue {
    background-color: red;
    color: #fff;
  }

  &--generation_failed {
    background-color: red;
    color: #fff;
  }

  &--validation_failed {
    background-color: red;
    color: #fff;
  }

  &--overdue {
    background-color: red;
    color: #fff;
  }

  &--in_queue {
    background: blue;
    color: #fff;
  }

  &--refunded {
    background-color: #3cb880;
  }

  &--negotiated {
    background-color: grey;
  }

  &--parceled {
    background-color: grey;
  }

  &--error {
    background: red;
    color: #fff;
  }

  &--pending_approval {
    background-color: #888;
  }

  &--free_pending {
    background-color: #888;
  }

  &--postponed {
    background-color: #ffd700;
    color: #fff;
  }
}

.sub-title {
  color: #999;
  font-size: 0.8rem;
}

.v-list__tile__sub-title {
  color: #999;
  font-size: 0.8rem;
}

.v-btn {
  height: 48px;
  padding: 7px 0px;
}

.v-btn.round {
  // padding-top: 50px;
  border-radius: 50%;
  height: 48px;
  // max-width: 28px;
  width: 48px;
  padding: 0%;
}

.error {
  font-size: 0.8rem;
  color: red;
}

.cemig-title {
  background-color: green;
  color: #fff;
  border-radius: 8px;
}

.borda {
  border: 2px solid #000;
  padding: 10px;
  margin: 5px;
}

.column {
  flex-direction: column;
}

.wrap {
  flex-wrap: wrap;
}

b {
  font-size: 16px;
  font-weight: 700;
}

.cemig-button {
  border-radius: 8px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  height: auto;
  width: auto;
}

.copy_pix {
  font-size: 13px;
  color: rgb(27, 24, 205);

  &:hover {
    transition: all 0.4s ease;
    opacity: 0.7;
  }
}
</style>
